import {fromJS} from 'immutable';
import {normalize} from 'normalizr';
import Cookies from 'js-cookie';
import {mergeEntitiesToState} from '../model/models';
import {ThreadSchema} from '../model/Thread';
import {ThreadEventSchema} from '../model/ThreadEvent';
import {ParticipantParticipantAttributeValueSchema} from '../model/ParticipantParticipantAttributeValue';
import {MessageTemplateSchema} from '../model/MessageTemplate';
import {AIReplySchema} from '../model/AIReply';

export default function init(data) {
    const normalized = normalize(data.thread, ThreadSchema);

    let state = fromJS({
        'participants': {},
        'threads': {},
        'threadAttributeValues': {},
        'threadEvents': {},
        'threadFiles': {},
        'threadTypes': {},
        'workflow': {},
        'workflowStatuses': {},
        'participantParticipantAttributeValues': {},
        'messageTemplates': {},
        'threadUploadedFiles': [],
        'aiReplies': {},
    });

    state = mergeEntitiesToState(state, normalized.entities);

    const normalizedAuthorAttributes = normalize(data.authorAttributes, [ParticipantParticipantAttributeValueSchema]);

    state = mergeEntitiesToState(state, normalizedAuthorAttributes.entities);

    const normalizedEvents = normalize(data.events, [ThreadEventSchema]);

    state = mergeEntitiesToState(state, normalizedEvents.entities);

    const normalizedMessageTemplates = normalize(data.messageTemplates, [MessageTemplateSchema]);

    state = mergeEntitiesToState(state, normalizedMessageTemplates.entities);

    const normalizedAIReplies = normalize(
        data.aiReply
            ? [{...data.aiReply, signature: data.aiReplySignature}]
            : [],
        [AIReplySchema]
    );

    state = mergeEntitiesToState(state, normalizedAIReplies.entities);

    state = state.merge(fromJS({
        currentThread: normalized.result,
        shownThreadEvents: normalizedEvents.result,
        threadSidebar: (Cookies.get('thread-sidebar-open') === 'true') || false,
        shownThreadEventsMeta: {
            loading: false,
            error: null,
            hasPrev: data.hasPrev,
        },
        threadOwnerMeta: {
            loading: false,
            error: null,
        },
        threadWorkflowStatusMeta: {
            loading: false,
            error: null,
        },
        threadInputMeta: {
            loading: false,
            error: null,
        },
        threadFileUploadMeta: {
            status: 0,
            readyState: XMLHttpRequest.UNSENT,
            inProgress: false,
        },
        threadNoteMeta: {
            loading: false,
            error: null,
        }
    }));

    return state;
}
